import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const ATVValidityModal = ({ show, onHide, onSubmit }) => {
  const [validity, setValidity] = useState({
    registrationDate: "",
    expiryYears: 4,
    expiryDate: "",
  });

  const calculateExpiryDate = (registrationDate, years) => {
    if (!registrationDate) return "";
    const date = new Date(registrationDate);
    date.setFullYear(date.getFullYear() + parseInt(years));
    return date.toISOString().split("T")[0];
  };

  const handleValidityChange = (field, value) => {
    const newValidity = { ...validity, [field]: value };

    if (field === "registrationDate" || field === "expiryYears") {
      newValidity.expiryDate = calculateExpiryDate(
        newValidity.registrationDate,
        newValidity.expiryYears
      );
    }

    setValidity(newValidity);
  };

  const handleSubmit = () => {
    onSubmit(validity);
    setValidity({
      registrationDate: "",
      expiryYears: 4,
      expiryDate: "",
    });
  };

  return (
    <Modal show={show} onHide={onHide} size="md" className="workshop-modal-scope">
      <Modal.Header closeButton>
        <Modal.Title>Atur Masa Berlaku ATV</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group style={{ marginBottom: "16px" }}>
            <Form.Label>Tanggal Pendaftaran</Form.Label>
            <Form.Control
              type="date"
              value={validity.registrationDate}
              onChange={(e) =>
                handleValidityChange("registrationDate", e.target.value)
              }
            />
          </Form.Group>
          <Form.Group style={{ marginBottom: "16px" }}>
            <Form.Label>Masa Berlaku (Tahun)</Form.Label>
            <Form.Select
              value={validity.expiryYears}
              onChange={(e) =>
                handleValidityChange("expiryYears", e.target.value)
              }
            >
              <option value={1}>1 Tahun</option>
              <option value={2}>2 Tahun</option>
              <option value={3}>3 Tahun</option>
              <option value={4}>4 Tahun</option>
              <option value={5}>5 Tahun</option>
            </Form.Select>
          </Form.Group>
          <Form.Group style={{ marginBottom: "16px" }}>
            <Form.Label>Tanggal Kadaluarsa</Form.Label>
            <Form.Control
              type="date"
              value={validity.expiryDate}
              readOnly
              style={{ backgroundColor: "#f8f9fa" }}
            />
            <Form.Text className="text-muted">
              Otomatis dihitung berdasarkan tanggal pendaftaran dan masa berlaku
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Batal
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Simpan
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ATVValidityModal;
